// extracted by mini-css-extract-plugin
export default {"section":"VWBxiqixW+","section-head":"XU1ytyVSRV","sectionHead":"XU1ytyVSRV"};
    if(module.hot) {
      // 1648554125132
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  